import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReferrerPortalService {
  constructor(
    private http: HttpClient
  ) { }

  getReferrerInfo(referrerId: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}`)
  }

  getReferrerals(referrerId: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals`)
  }
  
  getReferreralNotes(referrerId: string, referreralId: string, noteType: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referreralId}/notes/${noteType}`)
  }  

  getReferreralReports(referrerId: string, referreralId: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referreralId}/reports`)
  }
  
  getReferreralPrescriptions(referrerId: string, referreralId: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referreralId}/prescriptions`)
  }
    
  getReferreralImages(referrerId: string, referreralId: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referreralId}/images`)
  }
}

